import {
    CUSTOMER_DETAIL,
    CUSTOMER_DETAIL_FAIL,
    CUSTOMER_DETAIL_SUCCESS,
    CUSTOMER_LIST,
    CUSTOMER_LIST_FAIL,
    CUSTOMER_LIST_SUCCESS,
    CUSTOMER_STATUS_CHANGE,
    CUSTOMER_STATUS_CHANGE_FAIL,
    CUSTOMER_STATUS_CHANGE_SUCCESS,
} from "../../actions/admin/customer-actions";
import { call, put, takeLatest, } from "redux-saga/effects";
import { API } from "../../api";

function* customerList(action) {
    try {
        const response = yield call(API.customerList, action.payload);
        yield put({ type: CUSTOMER_LIST_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: CUSTOMER_LIST_FAIL, payload: { error: error } });
    }
}

function* customerStatusChange(action) {
    try {
        const { onSuccess } = action.payload;
        const response = yield call(API.customerStatusChange, action.payload);
        if (typeof onSuccess === "function") {
           onSuccess();
        }
        yield put({ type: CUSTOMER_STATUS_CHANGE_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: CUSTOMER_STATUS_CHANGE_FAIL, payload: { error: error } });
    }
    // try {
    //     const { id, is_suspended, onSuccess } = action.payload;
    
    //     // ✅ Only send relevant fields to the API
    //     const response = yield call(API.customerStatusChange, { id, is_suspended });
    
    //     if (typeof onSuccess === "function") {
    //       onSuccess();
    //     }
    
    //     yield put({ type: CUSTOMER_STATUS_CHANGE_SUCCESS, payload: response.data });
    //   } catch (error) {
    //     yield put({
    //       type: CUSTOMER_STATUS_CHANGE_FAIL,
    //       payload: { error: error },
    //     });
    //   }
}

function* customerDetail(action) {
    const customerId = action.payload?.id;
    try {
        const response = yield call(API.customerById, customerId);
        const body = response?.data;
        const detail = body?.data;
        if (!detail?.id) {
            yield put({
                type: CUSTOMER_DETAIL_FAIL,
                payload: { error: { data: { message: "Invalid customer response" } } },
            });
            return;
        }
        yield put({ type: CUSTOMER_DETAIL_SUCCESS, payload: body });
    } catch (error) {
        yield put({ type: CUSTOMER_DETAIL_FAIL, payload: { error } });
    }
}

function* customerSaga() {
    yield takeLatest(CUSTOMER_LIST, customerList);
    yield takeLatest(CUSTOMER_DETAIL, customerDetail);
    yield takeLatest(CUSTOMER_STATUS_CHANGE, customerStatusChange);
}
export default customerSaga;
